// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1y4pP","dragIcon":"SortableItem_dragIcon__1EUig","disabled":"SortableItem_disabled__1ig8u"};